import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-instagram-business-iq-checklist',
  templateUrl: './help-instagram-business-iq-checklist.component.html'
})
export class HelpInstagramBusinessIqChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
